/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Provider_Tried_FirstInputs */

const en_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tried first`)
};

const zh_hans1_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先调用`)
};

const pt_br2_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentado primeiro`)
};

const es_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se prueba primero`)
};

const fr_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayé en premier`)
};

const de_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuerst gefragt`)
};

const ru_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первый в очереди`)
};

const it_endpoint_provider_tried_first = /** @type {(inputs: Endpoint_Provider_Tried_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrogato per primo`)
};

/**
* | output |
* | --- |
* | "Tried first" |
*
* @param {Endpoint_Provider_Tried_FirstInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_provider_tried_first = /** @type {((inputs?: Endpoint_Provider_Tried_FirstInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Provider_Tried_FirstInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_provider_tried_first(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_provider_tried_first(inputs)
	if (locale === "es") return es_endpoint_provider_tried_first(inputs)
	if (locale === "fr") return fr_endpoint_provider_tried_first(inputs)
	if (locale === "de") return de_endpoint_provider_tried_first(inputs)
	if (locale === "ru") return ru_endpoint_provider_tried_first(inputs)
	if (locale === "it") return it_endpoint_provider_tried_first(inputs)
	return en_endpoint_provider_tried_first(inputs)
});